import React, { useEffect, useState } from "react";
import { currentuser } from "../../../util/currentuser";
import { errorMessage, successMessage } from "./Toaster";
import { handleSaveSearchdata, propertyListing } from "../../../api/idx";
import MultiRangeSlider from "../Components/MultiRangeSlider";
import Dropdown from "../../../components/form/input/Dropdown";
import Modal from "../../../components/Modal";
import BeachSun from "../../../assets/icons/Beach Sun Birds.svg";
import SwimmingPool from "../../../assets/icons/Swimming Pool Stairs.svg";
import AnimalHorse from "../../../assets/icons/Animal Horse.svg";
import GolfHole from "../../../assets/icons/Golf Hole Ball.svg";
import Housefilter from "../../../assets/icons/Housefilter.svg";
import BuildingHouse from "../../../assets/icons/HouseBuilding.svg";
import House from "../../../assets/icons/House.svg";
import Townhouse from "../../../assets/icons/House1.svg";
import condo from "../../../assets/icons/House2.svg";
import land from "../../../assets/icons/House4.svg";
import farm from "../../../assets/icons/farm-icon.svg";
import multifamily from "../../../assets/icons/House3.svg";
import luxury from "../../../assets/icons/luxury-icon.svg";
import HouseFilter from "../../../assets/icons/House Filter.svg";
import { Link } from "react-router-dom";
import Select from "react-select";
import { Filters } from "../ProductDetails";
import { cibDebian } from "@coreui/icons-pro";
import { useDispatch, useSelector } from "react-redux";
import { CListGroup } from "@coreui/react";
import CurrencyInput from "react-currency-input-field";
import {
  changeModelMultiFilter,
  changePropertyType,
  changeSpecialFeature,
  changeSubPropertyType,
  changeToAny,
  clearAll,
  onToggleFilter,
  resetPageNo,
} from "../../../state/filterActions";

type Props = {
  handlefilterpopup: any;
  sethandleFilterPopup: any;
  PropertyType: any;
  setPropertyType: any;
  filter: any;
  setFilter: any;
  savesearch: any;
  setsaveSearch: any;
  toggle: any;
  setToggle: any;
  filterlist: any;
  currrentfilter: any;
  setCurrentFilter: any;
  showSuggestions: any;
  setShowSuggestions: any;
  suggestions: any;
  setSuggestions: any;
  propertyTypeVal: any;
  setPropertyTypeVal: any;
  loading?: boolean;
  handleOnSearch?: any;
  setCityAddress?: any;
  setCount?: any;
  setAddress?: any;
};

const AllFilters: React.FC<Props> = (props) => {
  const {
    handlefilterpopup,
    sethandleFilterPopup,
    PropertyType,
    setPropertyType,
    filter,
    setFilter,
    savesearch,
    setsaveSearch,
    toggle,
    setToggle,
    filterlist,
    currrentfilter,
    setCurrentFilter,
    showSuggestions,
    setShowSuggestions,
    suggestions,
    setSuggestions,
    propertyTypeVal,
    setPropertyTypeVal,
    handleOnSearch,
    setCityAddress,
    loading,
    setCount,
    setAddress,
  } = props;

  const [savesearchtoggle, setsaveSearchToggle] = useState<boolean>(false);
  const [topFilter, setTopFilter] = useState<any>({
    city: null,
    country: "US", //@ts-ignore
    countyOrParish: null,
    zip: null,
    stateOrProvince: null,
    number_of_beds: null,
    number_of_baths: null,
    yearbuilt: null,
    highschool: null,
    elementaryschool: null,
    garageyn: null,
    horseyn: null,
    garagespaces: null,
    subdivisionname: null,
    highschooldistrict: null,
    waterfront: null,
    riverfront: null,
    lakefront: null,
    pool_In_Ground: null,
    pool_Above_Ground: null,
    pool_Access: null,
    horse_Permitted: null,
    out_Building: null,
    golf_Course: null,
    searchdata: null,
    lotFeatures: null,
    yearbuiltmin: null,
    yearbuiltmax: null,
    garagespacesmin: null,
    garagespacesmax: null,
    propertytype: null,
    propertysubtype: null,
    newconstructionyn: null,
    fireplacemin: null,
    fireplacemax: null,
    squarefeetmin: null,
    squarefeetmax: null,
    pricemin: null,
    pricemax: null,
    userid: null,
    pageSize: 20,
    pageNo: 1,
    luxury: null,
    streetNumber: null,
    lotrange: null,
    new_listing: null,
    lowest_price: null,
    highest_price: null,
    year_built: null,
    open_house_date: null,
    recently_reduced: null,
    largest_sqft: null,
    lot_size: null,
    daysonMarket: null,
    cityAddres: null,
  });

  const defaultfilter = {
    city: null,
    country: "US",
    countyOrParish: null,
    zip: null,
    stateOrProvince: null,
    number_of_beds: null,
    number_of_baths: null,
    yearbuilt: null,
    highschool: null,
    elementaryschool: null,
    garageyn: null,
    horseyn: null,
    garagespaces: null,
    subdivisionname: null,
    highschooldistrict: null,
    waterfront: null,
    riverfront: null,
    lakefront: null,
    pool_In_Ground: null,
    pool_Above_Ground: null,
    pool_Access: null,
    horse_Permitted: null,
    out_Building: null,
    golf_Course: null,
    searchdata: null,
    lotFeatures: null,
    yearbuiltmin: null,
    yearbuiltmax: null,
    garagespacesmin: null,
    garagespacesmax: null,
    propertytype: null,
    propertysubtype: null,
    newconstructionyn: null,
    fireplacemin: null,
    fireplacemax: null,
    squarefeetmin: null,
    squarefeetmax: null,
    pricemin: null,
    pricemax: null,
    userid: null,
    pageSize: 20,
    pageNo: 1,
    luxury: null,
    streetNumber: null,
    lotrange: null,
    new_listing: null,
    lowest_price: null,
    highest_price: null,
    year_built: null,
    open_house_date: null,
    recently_reduced: null,
    largest_sqft: null,
    lot_size: null,
    daysonMarket: null,
    cityAddres: null,
  };

  const handleDropdownData = (e: any, type: string, data: string) => {
    if (type === "minimum") {
      setFilter({ ...topFilter, [data]: e });
    }

    if (type === "maximum") {
      let errormessage = "Please select a value greater than the minimum.";
      switch (data) {
        case "yearbuiltmax":
          if (e < (topFilter?.yearbuiltmin ?? "")) {
            errorMessage(errormessage);
          } else {
            setFilter({ ...topFilter, [data]: e });
          }
          break;

        case "garagespacesmax":
          if (e < (topFilter?.garagespacesmin ?? "")) {
            errorMessage(errormessage);
          } else {
            setFilter({ ...topFilter, [data]: e });
          }
          break;

        case "fireplacemax":
          if (e < (topFilter?.fireplacemin ?? "")) {
            errorMessage(errormessage);
          } else {
            setFilter({ ...topFilter, [data]: e });
          }
          break;

        case "pricemax":
          if (e < (topFilter?.pricemin ?? "")) {
            errorMessage(errormessage);
          } else {
            setFilter({ ...topFilter, [data]: e });
          }
          break;

        case "squarefeetmax":
          if (e < (topFilter?.squarefeetmin ?? "")) {
            errorMessage(errormessage);
          } else {
            setFilter({ ...topFilter, [data]: e });
          }
          break;

        default:
          break;
      }
    }
  };

  const [lowerfilters, setlowerFIlter] = useState({
    number_of_beds: null,
    pricemin: null,
    pricemax: null,
    number_of_baths: null,
    squarefeetmin: null,
    squarefeetmax: null,
    garagespacesmin: null,
    garagespacesmax: null,
    yearbuiltmin: null,
    yearbuiltmax: null,
    fireplacemin: null,
    fireplacemax: null,
    lotFeatures: null,
    highschool: null,
    highschooldistrict: null,
    subdivisionname: null,
    zip: null,
    city: null,
    countyOrParish: null,
    newconstructionyn: null,
    daysonMarket: null,
  });

  // const [propertytype, setPropertytype] = useState([]);
  // const [propertysubtype, setPropertysubtype] = useState([]);
  const [propertysubtypeDrop, setPropertysubtypeDrop] = useState(null);

  // const [specialFeature, setSpecialFeature] = useState({
  //   luxury: null,
  //   golf_Course: null,
  //   horse_Permitted: null,
  //   pool_Access: null,
  //   waterfront: null,
  //   riverfront: null,
  //   lakefront: null,
  //   pool_In_Ground: null,
  //   pool_Above_Ground: null,
  //   out_Building: null,
  // });

  const specialFeature = useSelector(
    (store: any) => store?.filterReducer?.specialFeature
  );
  const propertytype = useSelector(
    (store: any) => store?.filterReducer?.propertytype
  );
  const propertysubtype = useSelector(
    (store: any) => store?.filterReducer?.propertysubtype
  );
  const modalFilter = useSelector(
    (store: any) => store?.filterReducer?.modalFilter
  );

  const clearFilter = useSelector(
    (store: any) => store?.filterReducer?.clearFilter
  );

  // const handleChangeSpecialFeature = (key: string, value: any) => {
  //   setSpecialFeature({ ...specialFeature, [key]: value });
  // };

  const handleFilterChange = (
    type: string,
    selectedValue: { label: string; value: number; state: boolean }
  ) => {
    switch (type) {
      case "etNoofBed":
        setlowerFIlter({ ...lowerfilters, number_of_beds: selectedValue });
        setTopFilter({ ...topFilter, number_of_beds: selectedValue.value });
        break;
      case "etNoofBath":
        setlowerFIlter({ ...lowerfilters, number_of_baths: selectedValue });
        setTopFilter({ ...topFilter, number_of_baths: selectedValue.value });
        break;
      case "priceMin":
        setlowerFIlter({ ...lowerfilters, pricemin: selectedValue });
        setTopFilter({ ...topFilter, pricemin: selectedValue.value });
        break;
      case "priceMax":
        setlowerFIlter({ ...lowerfilters, pricemax: selectedValue });
        setTopFilter({ ...topFilter, pricemax: selectedValue.value });
        break;
      case "squareFeetMin":
        setlowerFIlter({ ...lowerfilters, squarefeetmin: selectedValue });
        setTopFilter({ ...topFilter, squarefeetmin: selectedValue.value });
        break;
      case "squareFeetMax":
        setlowerFIlter({ ...lowerfilters, squarefeetmax: selectedValue });
        setTopFilter({ ...topFilter, squarefeetmax: selectedValue.value });
        break;
      case "garagespaceMin":
        setlowerFIlter({ ...lowerfilters, garagespacesmin: selectedValue });
        setTopFilter({ ...topFilter, garagespacesmin: selectedValue.value });
        break;
      case "garagespaceMax":
        setlowerFIlter({ ...lowerfilters, garagespacesmax: selectedValue });
        setTopFilter({ ...topFilter, garagespacesmax: selectedValue.value });
        break;
      case "yearbuiltMin":
        setlowerFIlter({ ...lowerfilters, yearbuiltmin: selectedValue });
        setTopFilter({ ...topFilter, yearbuiltmin: selectedValue.value });
        break;
      case "yearbuiltMax":
        setlowerFIlter({ ...lowerfilters, yearbuiltmax: selectedValue });
        setTopFilter({ ...topFilter, yearbuiltmax: selectedValue.value });
        break;
      case "fireplaceMin":
        setlowerFIlter({ ...lowerfilters, fireplacemin: selectedValue });
        setTopFilter({ ...topFilter, fireplacemin: selectedValue.value });
        break;
      case "fireplaceMax":
        setlowerFIlter({ ...lowerfilters, fireplacemax: selectedValue });
        setTopFilter({ ...topFilter, fireplacemax: selectedValue.value });
        break;
      case "lotRange":
        setlowerFIlter({ ...lowerfilters, lotFeatures: selectedValue }); //@ts-ignore
        setTopFilter({
          ...topFilter, //@ts-ignore
          lotFeatures: selectedValue.value,
        });
        break;
      case "highSchool":
        setlowerFIlter({ ...lowerfilters, highschool: selectedValue });
        setTopFilter({
          ...topFilter,
          highschool: selectedValue.value,
        });
        break;
      case "highSchoolDistrict":
        setlowerFIlter({ ...lowerfilters, highschooldistrict: selectedValue });
        setTopFilter({
          ...topFilter,
          highschooldistrict: selectedValue.value,
        });
        break;
      case "subdivisionName":
        setlowerFIlter({ ...lowerfilters, subdivisionname: selectedValue });
        setTopFilter({
          ...topFilter,
          subdivisionname: selectedValue.value,
        });
        break;
      case "propertySubtype":
        setPropertysubtypeDrop(selectedValue);
        // handleChangePropertySubType(selectedValue?.value)
        dispatch(changeSubPropertyType(selectedValue?.value));
        setTopFilter({
          ...topFilter,
          propertysubtype: selectedValue.value,
        });
        break;
      case "zipCode":
        setlowerFIlter({ ...lowerfilters, zip: selectedValue });
        setTopFilter({ ...topFilter, zip: selectedValue.value });
        break;
      case "cityName":
        setlowerFIlter({ ...lowerfilters, city: selectedValue });
        setTopFilter({ ...topFilter, city: selectedValue.value });
        break;
      case "countryName":
        setlowerFIlter({ ...lowerfilters, countyOrParish: selectedValue }); //@ts-ignore
        setTopFilter({
          ...topFilter, //@ts-ignore
          countyOrParish: selectedValue.value,
        });
        break;
      case "lotFeatures":
        setlowerFIlter({ ...lowerfilters, lotFeatures: selectedValue });
        setTopFilter({ ...topFilter, lotFeatures: selectedValue.label });
        break;
      default:
        console.error(`Unknown filter type: ${type}`);
    }
  };

  const handleConstructionChange = (selectedValue: {
    label: string;
    value: boolean;
  }) => {
    setlowerFIlter({ ...lowerfilters, newconstructionyn: selectedValue });
    setTopFilter({ ...topFilter, newconstructionyn: selectedValue.value });
  };
  const handledaysonMarket = (selectedValue: {
    label: string;
    value: number;
  }) => {
    setlowerFIlter({ ...lowerfilters, daysonMarket: selectedValue }); //@ts-ignore
    setTopFilter({ ...topFilter, daysonMarket: selectedValue.value });
  };

  const handleClearAll = () => {
    // setTopFilter({
    //   city: null,
    //   country: null, //@ts-ignore
    //   countyOrParish: null,
    //   zip: null,
    //   stateOrProvince: null,
    //   number_of_beds: null,
    //   number_of_baths: null,
    //   yearbuilt: null,
    //   highschool: null,
    //   elementaryschool: null,
    //   garageyn: null,
    //   horseyn: null,
    //   garagespaces: null,
    //   subdivisionname: null,
    //   highschooldistrict: null,
    //   waterfront: null,
    //   riverfront: null,
    //   lakefront: null,
    //   pool_In_Ground: null,
    //   pool_Above_Ground: null,
    //   pool_Access: null,
    //   horse_Permitted: null,
    //   out_Building: null,
    //   golf_Course: null,
    //   searchdata: null,
    //   lotFeatures: null,
    //   yearbuiltmin: null,
    //   yearbuiltmax: null,
    //   garagespacesmin: null,
    //   garagespacesmax: null,
    //   propertytype: null,
    //   propertysubtype: null,
    //   newconstructionyn: null,
    //   fireplacemin: null,
    //   fireplacemax: null,
    //   squarefeetmin: null,
    //   squarefeetmax: null,
    //   pricemin: null,
    //   pricemax: null,
    //   userid: null,
    //   pageSize: 20,
    //   pageNo: 1,
    //   luxury: null,
    //   streetNumber: null,
    //   lotrange: null,
    //   new_listing: null,
    //   lowest_price: null,
    //   highest_price: null,
    //   year_built: null,
    //   open_house_date: null,
    //   recently_reduced: null,
    //   largest_sqft: null,
    //   lot_size: null,
    //   daysonMarket: null,
    //   cityAddres: null,
    // });
    setlowerFIlter({
      number_of_beds: null,
      pricemin: null,
      pricemax: null,
      number_of_baths: null,
      squarefeetmin: null,
      squarefeetmax: null,
      garagespacesmin: null,
      garagespacesmax: null,
      yearbuiltmin: null,
      yearbuiltmax: null,
      fireplacemin: null,
      fireplacemax: null,
      lotFeatures: null,
      highschool: null,
      highschooldistrict: null,
      subdivisionname: null,
      zip: null,
      city: null,
      countyOrParish: null,
      newconstructionyn: null,
      daysonMarket: null,
    });
    // setActive(null);
    // localStorage.removeItem("onaddressbar");
    // setAddress("");
    // //@ts-ignore
    // setPropertyTypeVal(null); //@ts-ignore
    // localStorage.setItem("filtervalue", defaultfilter); //@ts-ignore
    // localStorage.getItem("filtervalue", defaultfilter);
    // setCount(0);
    // dispatch({
    //   type: "SET",
    //   payload: defaultfilter,
    // });
  };

  const dispatch = useDispatch();
  //@ts-ignore
  const val = useSelector((state) => state?.new?.signset);
  useEffect(() => {
    handleSubmit();
  }, [clearFilter]);
  const handleSubmit = async () => {
    setCount(
      Object.entries({ ...modalFilter, ...specialFeature }).filter(
        ([key, value]) =>
          value !== null &&
          ![
            "country",
            "pageNo",
            "pageSize",
            "new_listing",
            "lowest_price",
            "highest_price",
            "year_built",
            "open_house_date",
            "recently_reduced",
            "largest_sqft",
            "lot_size",
          ].includes(key)
      ).length +
        propertytype.length +
        propertysubtype.length
    );
    // setPropertyTypeVal(active);
    // try {
    //   dispatch({
    //     type: "SET",
    //     payload: topFilter,
    //   });
    //   sethandleFilterPopup(false);
    //   handleOnSearch(topFilter?.city);
    // } catch (error) {
    //   console.log(error);
    // }
  };

  const options = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ];

  const optionsConverter = (options) => {
    return options.map((option) => ({
      value: option.value,
      label: option.label,
    }));
  };

  const daysOptions = optionsConverter([
    { value: null, label: "Any" },
    { value: 7, label: "7" },
    { value: 14, label: "14" },
    { value: 21, label: "21" },
    // ...
  ]);

  const [activeFilter, setActiveFilter] = useState(null);
  const [active, setActive] = useState(null);
  const handlefilters = (type: string) => {
    if (type == null) {
      setTopFilter({ ...defaultfilter, propertytype: null });
      setActive(null);
    }
    if (type == "House") {
      setTopFilter({ ...defaultfilter, propertytype: "Residential" });
      setActive("House");
    }
    if (type === "Townhouse") {
      setTopFilter({ ...defaultfilter, propertysubtype: "Townhouse" });
      setActive("Townhouse");
    }
    if (type === "Condominium") {
      setTopFilter({ ...defaultfilter, propertysubtype: "Condominium" });
      setActive("Condominium");
    }
    if (type === "Villa/Patio Home") {
      setTopFilter({ ...defaultfilter, propertysubtype: "Villa/Patio Home" });
      setActive("Villa/Patio Home");
    }
    if (type === "Luxury") {
      setTopFilter({ ...defaultfilter, luxury: true });
      setActive("Luxury");
    }
    if (type === "Multi Family") {
      setTopFilter({ ...defaultfilter, propertysubtype: "Multi Family" });
      setActive("Multi Family");
    }
    if (type === "Land") {
      setTopFilter({ ...defaultfilter, propertytype: "Land" });
      setActive("Land");
    }
    if (type === "Farm") {
      setTopFilter({ ...defaultfilter, propertytype: "Farm" });
      setActive("Farm");
    } else {
      return;
    }
    setActiveFilter(type);
  };

  // const handleChangePropertyType = (type) =>{
  //   if(propertytype.includes(type)){
  //     setPropertytype(propertytype.filter(pt=>pt != type))
  //   }else{
  //     setPropertytype([...propertytype,type])
  //   }
  // }

  // const handleChangePropertySubType = (type) =>{
  //   if(propertysubtype.includes(type)){
  //     setPropertysubtype(propertysubtype.filter(pt=>pt != type))
  //   }else{
  //     setPropertysubtype([...propertysubtype,type])
  //   }
  // }

  const checkAny = () => {
    if (
      !propertytype.includes("Residential") &&
      !propertysubtype.includes("Townhouse") &&
      !propertysubtype.includes("Condominium") &&
      !propertysubtype.includes("Villa/Patio Home") &&
      !specialFeature?.luxury &&
      !propertysubtype.includes("Multi Family") &&
      !propertytype.includes("Land") &&
      !propertysubtype.includes("Farm")
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div
      className={handlefilterpopup ? "modal fade show" : "modal fade"}
      id="idx-filter-modal"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title" id="exampleModalLabel">
              Filters
            </h4>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => sethandleFilterPopup(false)}
            ></button>
          </div>
          <div className="modal-body">
            <form className="filter-modal-form">
              <div className="row">
                <div className="col-md-12">
                  <h6 className="mb-4 mt-4">Property Type</h6>
                  <div className="display-flex grid-cusom mb-3">
                    <span
                      className={checkAny() ? "rectangle active" : "rectangle"}
                      onClick={() => {
                        // handlefilters(null);
                        dispatch(changeToAny());
                      }}
                    >
                      <div>
                        <span>
                          <img
                            src={BuildingHouse}
                            className="custome-color buildingsvg"
                          />
                        </span>
                        <span>Any</span>
                      </div>
                    </span>
                    <span
                      className={
                        propertytype.includes("Residential")
                          ? "rectangle active"
                          : "rectangle"
                      }
                      onClick={() => {
                        // handleChangePropertyType("Residential");
                        dispatch(changePropertyType("Residential"));
                      }}
                    >
                      <div>
                        <span>
                          <img src={House} className="custome-color" />
                        </span>
                        <span>House</span>
                      </div>
                    </span>
                    <span
                      className={
                        propertysubtype.includes("Townhouse")
                          ? "rectangle active"
                          : "rectangle"
                      }
                      onClick={() => {
                        // handleChangePropertySubType("Townhouse");
                        dispatch(changeSubPropertyType("Townhouse"));
                      }}
                    >
                      <div>
                        <span>
                          <img src={Townhouse} className="custome-color" />
                        </span>
                        <span>Townhouse</span>
                      </div>
                    </span>
                    <span
                      className={
                        propertysubtype.includes("Condominium")
                          ? "rectangle active"
                          : "rectangle"
                      }
                      onClick={() => {
                        // handleChangePropertySubType("Condominium");
                        dispatch(changeSubPropertyType("Condominium"));
                      }}
                    >
                      <div>
                        <span>
                          <img src={condo} className="custome-color" />
                        </span>
                        <span>Condo</span>
                      </div>
                    </span>
                    <span
                      className={
                        propertysubtype.includes("Multi Family")
                          ? "rectangle active"
                          : "rectangle"
                      }
                      onClick={() => {
                        // handleChangePropertySubType("Multi Family");
                        dispatch(changeSubPropertyType("Multi Family"));
                      }}
                    >
                      <div>
                        <span>
                          <img src={multifamily} className="custome-color" />
                        </span>
                        <span>Multi-family</span>
                      </div>
                    </span>
                    <span
                      className={
                        specialFeature?.luxury
                          ? "rectangle active"
                          : "rectangle"
                      }
                      onClick={() => {
                        // handleChangeSpecialFeature("luxury",specialFeature?.luxury ? null : true);
                        dispatch(
                          changeSpecialFeature({
                            luxury: specialFeature?.luxury ? null : true,
                          })
                        );
                      }}
                    >
                      <div>
                        <span>
                          <img src={luxury} className="custome-color" />
                        </span>
                        <span>Luxury</span>
                      </div>
                    </span>
                    <span
                      className={
                        propertysubtype.includes("Villa/Patio Home")
                          ? "rectangle active"
                          : "rectangle"
                      }
                      onClick={() => {
                        // handleChangePropertySubType("Villa/Patio Home");
                        dispatch(changeSubPropertyType("Villa/Patio Home"));
                      }}
                    >
                      <div>
                        <span>
                          <img src={luxury} className="custome-color" />
                        </span>
                        <span>Villa</span>
                      </div>
                    </span>
                    <span
                      className={
                        propertysubtype.includes("Farm")
                          ? "rectangle active"
                          : "rectangle"
                      }
                      onClick={() => {
                        // handleChangePropertySubType("Farm");
                        dispatch(changeSubPropertyType("Farm"));
                      }}
                    >
                      <div>
                        <span>
                          <img src={farm} className="custome-color" />
                        </span>
                        <span>Farms</span>
                      </div>
                    </span>
                    <span
                      className={
                        propertytype.includes("Land")
                          ? "rectangle active"
                          : "rectangle"
                      }
                      onClick={() => {
                        // handleChangePropertyType("Land");
                        dispatch(changePropertyType("Land"));
                      }}
                    >
                      <div>
                        <span>
                          <img src={land} className="custome-color" />
                        </span>
                        <span>Land</span>
                      </div>
                    </span>
                  </div>
                  <div className="display-flex"></div>
                </div>
                <div className="col-md-12">
                  <div className="slider-range">
                    <div className="mainrangebg mt-5">
                      <h6>Price Range</h6>
                      <div className="col-md-12">
                        <div className="price-range-main"></div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 range-drop">
                          <Select
                            className="range-select"
                            value={lowerfilters?.pricemin}
                            onChange={(selectedValue: any) => {
                              dispatch(
                                changeModelMultiFilter({
                                  pricemin: selectedValue?.value,
                                })
                              );
                              //@ts-ignore
                              handleFilterChange("priceMin", selectedValue);
                            }}
                            placeholder="Any"
                            options={[
                              {
                                label: "Any",
                                value: null,
                              },
                              {
                                label: "$10K",
                                value: 10000,
                              },
                              {
                                label: "$25K",
                                value: 25000,
                              },
                              {
                                label: "$50K",
                                value: 50000,
                              },
                              {
                                label: "$100K",
                                value: 100000,
                              },
                              ...Array.from({ length: 16 }, (_, i) => ({
                                label: `$${50 * i + 150}K`,
                                value: (50 * i + 150) * 1000,
                              })),
                              {
                                label: `$1M`,
                                value: 1000000,
                              },
                              {
                                label: `$2M`,
                                value: 2000000,
                              },
                              {
                                label: `$3M+`,
                                value: 3000000,
                              },
                            ]}
                          />
                        </div>
                        <div className="col-md-6 range-drop">
                          <Select
                            className="range-select"
                            value={lowerfilters?.pricemax}
                            onChange={(selectedValue: { value: number }) => {
                              dispatch(
                                changeModelMultiFilter({
                                  pricemax: selectedValue?.value,
                                })
                              );
                              //@ts-ignore
                              handleFilterChange("priceMax", selectedValue);
                            }}
                            placeholder="Any"
                            options={[
                              {
                                label: "Any",
                                value: null,
                              },
                              {
                                label: "$10K",
                                value: 10000,
                              },
                              {
                                label: "$25K",
                                value: 25000,
                              },
                              {
                                label: "$50K",
                                value: 50000,
                              },
                              {
                                label: "$100K",
                                value: 100000,
                              },
                              ...Array.from({ length: 16 }, (_, i) => ({
                                label: `$${50 * i + 150}K`,
                                value: (50 * i + 150) * 1000,
                              })),
                              {
                                label: `$1M`,
                                value: 1000000,
                              },
                              {
                                label: `$2M`,
                                value: 2000000,
                              },
                              {
                                label: `$3M+`,
                                value: 3000000,
                              },
                            ]}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="bedrooms mt-4">
                    <h6 className="mb-3">Bedrooms</h6>
                    <div className="bedrooms-btn">
                      <span
                        className={
                          modalFilter.number_of_beds === null
                            ? "btn btn-circle active"
                            : "btn btn-circle"
                        }
                        onClick={() => {
                          dispatch(
                            changeModelMultiFilter({ number_of_beds: null })
                          );
                          handleFilterChange("etNoofBed", {
                            label: "any",
                            value: null,
                            state: null,
                          });
                        }}
                      >
                        Any
                      </span>
                      <span
                        className={
                          modalFilter.number_of_beds === 1
                            ? "btn btn-circle active"
                            : "btn btn-circle"
                        }
                        onClick={() => {
                          dispatch(
                            changeModelMultiFilter({ number_of_beds: 1 })
                          );
                          handleFilterChange("etNoofBed", {
                            label: "1",
                            value: 1,
                            state: null,
                          });
                        }}
                      >
                        1
                      </span>
                      <span
                        className={
                          modalFilter.number_of_beds === 2
                            ? "btn btn-circle active"
                            : "btn btn-circle"
                        }
                        onClick={() => {
                          dispatch(
                            changeModelMultiFilter({ number_of_beds: 2 })
                          );
                          handleFilterChange("etNoofBed", {
                            label: "2",
                            value: 2,
                            state: null,
                          });
                        }}
                      >
                        2
                      </span>
                      <span
                        className={
                          modalFilter.number_of_beds === 3
                            ? "btn btn-circle active"
                            : "btn btn-circle"
                        }
                        onClick={() => {
                          dispatch(
                            changeModelMultiFilter({ number_of_beds: 3 })
                          );
                          handleFilterChange("etNoofBed", {
                            label: "3",
                            value: 3,
                            state: null,
                          });
                        }}
                      >
                        3
                      </span>
                      <span
                        className={
                          modalFilter.number_of_beds === 4
                            ? "btn btn-circle active"
                            : "btn btn-circle"
                        }
                        onClick={() => {
                          dispatch(
                            changeModelMultiFilter({ number_of_beds: 4 })
                          );
                          handleFilterChange("etNoofBed", {
                            label: "4",
                            value: 4,
                            state: null,
                          });
                        }}
                      >
                        4
                      </span>
                      <span
                        className={
                          modalFilter.number_of_beds === 5
                            ? "btn btn-circle active"
                            : "btn btn-circle"
                        }
                        onClick={() => {
                          dispatch(
                            changeModelMultiFilter({ number_of_beds: 5 })
                          );
                          handleFilterChange("etNoofBed", {
                            label: "5",
                            value: 5,
                            state: null,
                          });
                        }}
                      >
                        5
                      </span>
                      <span
                        className={
                          modalFilter.number_of_beds === 6
                            ? "btn btn-circle active"
                            : "btn btn-circle"
                        }
                        onClick={() => {
                          dispatch(
                            changeModelMultiFilter({ number_of_beds: 6 })
                          );
                          handleFilterChange("etNoofBed", {
                            label: "6",
                            value: 6,
                            state: null,
                          });
                        }}
                      >
                        6
                      </span>
                      <span
                        className={
                          modalFilter.number_of_beds === 7
                            ? "btn btn-circle active"
                            : "btn btn-circle"
                        }
                        onClick={() => {
                          dispatch(
                            changeModelMultiFilter({ number_of_beds: 7 })
                          );
                          handleFilterChange("etNoofBed", {
                            label: "7",
                            value: 7,
                            state: null,
                          });
                        }}
                      >
                        7
                      </span>
                      <span
                        className={
                          modalFilter.number_of_beds === 8
                            ? "btn btn-circle active"
                            : "btn btn-circle"
                        }
                        onClick={() => {
                          dispatch(
                            changeModelMultiFilter({ number_of_beds: 8 })
                          );
                          handleFilterChange("etNoofBed", {
                            label: "8",
                            value: 8,
                            state: null,
                          });
                        }}
                      >
                        8+
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="bedrooms mt-5">
                    <h6 className="mb-3">Bathrooms</h6>
                    <div className="bedrooms-btn">
                      <span
                        className={
                          modalFilter.number_of_baths === null
                            ? "btn btn-circle active"
                            : "btn btn-circle"
                        }
                        onClick={() => {
                          dispatch(
                            changeModelMultiFilter({ number_of_baths: null })
                          );
                          handleFilterChange("etNoofBath", {
                            label: "any",
                            value: null,
                            state: null,
                          });
                        }}
                      >
                        Any
                      </span>
                      <span
                        className={
                          modalFilter.number_of_baths === 1
                            ? "btn btn-circle active"
                            : "btn btn-circle"
                        }
                        onClick={() => {
                          dispatch(
                            changeModelMultiFilter({ number_of_baths: 1 })
                          );
                          handleFilterChange("etNoofBath", {
                            label: "1",
                            value: 1,
                            state: null,
                          });
                        }}
                      >
                        1
                      </span>
                      <span
                        className={
                          modalFilter.number_of_baths === 2
                            ? "btn btn-circle active"
                            : "btn btn-circle"
                        }
                        onClick={() => {
                          dispatch(
                            changeModelMultiFilter({ number_of_baths: 2 })
                          );
                          handleFilterChange("etNoofBath", {
                            label: "2",
                            value: 2,
                            state: null,
                          });
                        }}
                      >
                        2
                      </span>
                      <span
                        className={
                          modalFilter.number_of_baths === 3
                            ? "btn btn-circle active"
                            : "btn btn-circle"
                        }
                        onClick={() => {
                          dispatch(
                            changeModelMultiFilter({ number_of_baths: 3 })
                          );
                          handleFilterChange("etNoofBath", {
                            label: "3",
                            value: 3,
                            state: null,
                          });
                        }}
                      >
                        3
                      </span>
                      <span
                        className={
                          modalFilter.number_of_baths === 4
                            ? "btn btn-circle active"
                            : "btn btn-circle"
                        }
                        onClick={() => {
                          dispatch(
                            changeModelMultiFilter({ number_of_baths: 4 })
                          );
                          handleFilterChange("etNoofBath", {
                            label: "4",
                            value: 4,
                            state: null,
                          });
                        }}
                      >
                        4
                      </span>
                      <span
                        className={
                          modalFilter.number_of_baths === 5
                            ? "btn btn-circle active"
                            : "btn btn-circle"
                        }
                        onClick={() => {
                          dispatch(
                            changeModelMultiFilter({ number_of_baths: 5 })
                          );
                          handleFilterChange("etNoofBath", {
                            label: "5",
                            value: 5,
                            state: null,
                          });
                        }}
                      >
                        5
                      </span>
                      <span
                        className={
                          modalFilter.number_of_baths === 6
                            ? "btn btn-circle active"
                            : "btn btn-circle"
                        }
                        onClick={() => {
                          dispatch(
                            changeModelMultiFilter({ number_of_baths: 6 })
                          );
                          handleFilterChange("etNoofBath", {
                            label: "6",
                            value: 6,
                            state: null,
                          });
                        }}
                      >
                        {" "}
                        6
                      </span>
                      <span
                        className={
                          modalFilter.number_of_baths === 7
                            ? "btn btn-circle active"
                            : "btn btn-circle"
                        }
                        onClick={() => {
                          dispatch(
                            changeModelMultiFilter({ number_of_baths: 7 })
                          );
                          handleFilterChange("etNoofBath", {
                            label: "7",
                            value: 7,
                            state: null,
                          });
                        }}
                      >
                        7
                      </span>
                      <span
                        className={
                          modalFilter.number_of_baths === 8
                            ? "btn btn-circle active"
                            : "btn btn-circle"
                        }
                        onClick={() => {
                          dispatch(
                            changeModelMultiFilter({ number_of_baths: 8 })
                          );
                          handleFilterChange("etNoofBath", {
                            label: "8",
                            value: 8,
                            state: null,
                          });
                        }}
                      >
                        8+
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 idx-input-margin-top range-drop">
                  <h6 className="mb-3">Square Feet</h6>
                  <div className="row adjust-margin">
                    <div className="col-md-6 pl-2">
                      <div className="dropdown">
                        <Select
                          className="range-select"
                          value={lowerfilters?.squarefeetmin}
                          onChange={(selectedValue: { value: number }) => {
                            dispatch(
                              changeModelMultiFilter({
                                squarefeetmin: selectedValue?.value,
                              })
                            );
                            //@ts-ignore
                            handleFilterChange("squareFeetMin", selectedValue);
                          }}
                          // placeholder="No min"
                          placeholder="Any"
                          options={[
                            {
                              label: "Any",
                              value: null,
                            },
                            ...filterlist.squarefeet
                              ?.slice(0, 10)
                              ?.map((v: string) => ({
                                label: v,
                                value: parseInt(v),
                              })),
                          ]}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 pl-2">
                      <div className="dropdown custom-margin">
                        <Select
                          className="range-select"
                          value={lowerfilters?.squarefeetmax}
                          onChange={(selectedValue: { value: number }) => {
                            dispatch(
                              changeModelMultiFilter({
                                squarefeetmax: selectedValue?.value,
                              })
                            );
                            //@ts-ignore
                            handleFilterChange("squareFeetMax", selectedValue);
                          }}
                          placeholder="Any"
                          options={[
                            {
                              label: "Any",
                              value: null,
                            },
                            ...filterlist.squarefeet
                              ?.slice(7, 17)
                              .map((v: string) => ({
                                label: v,
                                value: parseInt(v),
                              })),
                          ]}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 idx-input-margin-top range-drop">
                  <h6 className="mb-3">Property Subtype</h6>
                  <Select
                    className="range-select"
                    value={propertysubtypeDrop}
                    onChange={(selectedValue: number) => {
                      //@ts-ignore
                      handleFilterChange("propertySubtype", selectedValue);
                    }}
                    // placeholder="Search"
                    placeholder="Any"
                    options={[
                      {
                        label: "Any",
                        value: null,
                      },
                      ...filterlist.propertysubtype
                        ?.filter(
                          (pt) =>
                            pt != "Townhouse" &&
                            pt != "Condominium" &&
                            pt != "Multi Family" &&
                            pt != "Villa/Patio Home" &&
                            pt != "Farm"
                        )
                        ?.map((v: string) => ({
                          label: v,
                          value: v,
                        })),
                    ]}
                  />
                </div>
                <div className="col-md-6 mt-3 range-drop">
                  <h6 className="mb-3">School District</h6>
                  <Select
                    className="range-select"
                    value={lowerfilters?.highschooldistrict}
                    onChange={(selectedValue) => {
                      dispatch(
                        changeModelMultiFilter({
                          highschooldistrict: selectedValue?.value,
                        })
                      );
                      handleFilterChange("highSchoolDistrict", selectedValue);
                    }}
                    // placeholder="Search"
                    placeholder="Any"
                    options={[
                      {
                        label: "Any",
                        value: null,
                      },
                      ...filterlist.highschooldistrict?.map((v: string) => ({
                        label: v,
                        value: v,
                      })),
                    ]}
                  />
                </div>
                <div className="col-md-6 mt-3 range-drop">
                  <h6 className="mb-3">High School</h6>
                  <Select
                    className="range-select"
                    value={lowerfilters?.highschool}
                    onChange={(selectedValue) => {
                      dispatch(
                        changeModelMultiFilter({
                          highschool: selectedValue?.value,
                        })
                      );
                      handleFilterChange("highSchool", selectedValue);
                    }}
                    placeholder="Any"
                    options={[
                      {
                        label: "Any",
                        value: null,
                      },
                      ...filterlist.highschool?.map((v: string) => ({
                        label: v,
                        value: v,
                      })),
                    ]}
                  />
                </div>
                <div className="col-md-6 idx-input-margin-top range-drop">
                  <h6 className="mb-3">Subdivision</h6>
                  <Select
                    className="range-select"
                    value={lowerfilters?.subdivisionname}
                    onChange={(selectedValue) => {
                      dispatch(
                        changeModelMultiFilter({
                          subdivisionname: selectedValue?.value,
                        })
                      );
                      handleFilterChange("subdivisionName", selectedValue);
                    }}
                    placeholder="Any"
                    options={[
                      {
                        label: "Any",
                        value: null,
                      },
                      ...filterlist.subdivisionname?.map((v: string) => ({
                        label: v,
                        value: v,
                      })),
                    ]}
                  />
                </div>
                <div className="col-md-6 idx-input-margin-top range-drop">
                  <h6 className="mb-3">Zip code</h6>
                  <Select
                    className="range-select"
                    value={lowerfilters?.zip}
                    onChange={(selectedValue) => {
                      dispatch(
                        changeModelMultiFilter({ zip: selectedValue?.value })
                      );
                      handleFilterChange("zipCode", selectedValue);
                    }}
                    placeholder="Any"
                    options={[
                      {
                        label: "Any",
                        value: null,
                      },
                      ...filterlist.zip?.map((v: string) => ({
                        label: v,
                        value: v,
                      })),
                    ]}
                  />
                </div>
                <div className="col-md-6 idx-input-margin-top range-drop">
                  <h6 className="mb-3">City</h6>
                  <Select
                    className="range-select"
                    value={lowerfilters?.city}
                    onChange={(selectedValue) => {
                      dispatch(
                        changeModelMultiFilter({ city: selectedValue?.value })
                      );
                      handleFilterChange("cityName", selectedValue);
                    }}
                    placeholder="Any"
                    options={[
                      {
                        label: "Any",
                        value: null,
                      },
                      ...filterlist.city?.map((v: string) => ({
                        label: v,
                        value: v,
                      })),
                    ]}
                  />
                </div>
                <div className="col-md-6 idx-input-margin-top range-drop">
                  <h6 className="mb-3">County</h6>
                  <Select
                    className="range-select"
                    value={lowerfilters?.countyOrParish}
                    onChange={(selectedValue) => {
                      dispatch(
                        changeModelMultiFilter({
                          countyOrParish: selectedValue?.value,
                        })
                      );
                      handleFilterChange("countryName", selectedValue);
                    }}
                    placeholder="Any"
                    options={[
                      {
                        label: "Any",
                        value: null,
                      },
                      ...filterlist.country?.map((v: string) => ({
                        label: v,
                        value: v,
                      })),
                    ]}
                  />
                </div>
                <div className="col-md-6 idx-input-margin-top range-drop">
                  <h6 className="mb-3">Lot range</h6>
                  <Select
                    className="range-select"
                    value={lowerfilters?.lotFeatures}
                    onChange={(selectedValue) => {
                      dispatch(
                        changeModelMultiFilter({
                          lotFeatures: selectedValue?.value,
                        })
                      );
                      handleFilterChange("lotRange", selectedValue);
                    }}
                    placeholder="Any"
                    options={[
                      {
                        label: "Any",
                        value: null,
                      },
                      ...filterlist.lotrange?.map((v: string) => ({
                        label: v,
                        value: v,
                      })),
                    ]}
                  />
                </div>
                <div className="col-md-6 idx-input-margin-top range-drop">
                  <h6 className="mb-3">New Construction</h6>
                  <div className="row">
                    <div className="col-md-12 range-drop">
                      <Select
                        className="range-select"
                        value={options.find((opt) =>
                          filter.newconstructionyn === opt.value ? true : false
                        )}
                        onChange={(e) => {
                          dispatch(
                            changeModelMultiFilter({
                              newconstructionyn: e?.value,
                            })
                          );
                          handleConstructionChange(e);
                        }}
                        placeholder="Any"
                        options={[
                          {
                            label: "Any",
                            value: null,
                          },
                          ...options,
                        ]}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6 idx-input-margin-top">
                  <h6 className="mb-3">Garage spaces</h6>
                  <div className="row">
                    <div className="col-md-6 pl-2">
                      <div className="range-drop">
                        <Select
                          className="range-select"
                          value={lowerfilters.garagespacesmin}
                          onChange={(selectedValue) => {
                            dispatch(
                              changeModelMultiFilter({
                                garagespacesmin: selectedValue?.value,
                              })
                            );
                            handleFilterChange("garagespaceMin", selectedValue);
                          }}
                          placeholder="Any"
                          options={[
                            {
                              label: "Any",
                              value: null,
                            },
                            ...filterlist.garagespace?.map((v: string) => ({
                              label: v,
                              value: parseInt(v),
                            })),
                          ]}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 pl-2">
                      <div className="dropdown custom-margin range-drop">
                        <Select
                          className="range-select"
                          value={lowerfilters.garagespacesmax}
                          onChange={(selectedValue) => {
                            dispatch(
                              changeModelMultiFilter({
                                garagespacesmax: selectedValue?.value,
                              })
                            );
                            handleFilterChange("garagespaceMax", selectedValue);
                          }}
                          placeholder="Any"
                          options={[
                            {
                              label: "Any",
                              value: null,
                            },
                            ...filterlist.garagespace?.map((v: string) => ({
                              label: v,
                              value: parseInt(v),
                            })),
                          ]}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 idx-input-margin-top">
                  <h6 className="mb-3">Year built</h6>
                  <div className="row">
                    <div className="col-md-6 pl-2">
                      <div className="dropdown range-drop">
                        <Select
                          className="range-select"
                          value={lowerfilters.yearbuiltmin}
                          onChange={(selectedValue) => {
                            dispatch(
                              changeModelMultiFilter({
                                yearbuiltmin: selectedValue?.value,
                              })
                            );
                            handleFilterChange("yearbuiltMin", selectedValue);
                          }}
                          placeholder="Any"
                          options={[
                            {
                              label: "Any",
                              value: null,
                            },
                            ...filterlist.yearbuilt?.map((v: string) => ({
                              label: v,
                              value: parseInt(v),
                            })),
                          ]}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 pl-2">
                      <div className="dropdown custom-margin range-drop">
                        <Select
                          className="range-select"
                          value={lowerfilters.yearbuiltmax}
                          placeholder="Any"
                          onChange={(selectedValue) => {
                            dispatch(
                              changeModelMultiFilter({
                                yearbuiltmax: selectedValue?.value,
                              })
                            );
                            handleFilterChange("yearbuiltMax", selectedValue);
                          }}
                          options={[
                            {
                              label: "Any",
                              value: null,
                            },
                            ...filterlist.yearbuilt?.map((v: string) => ({
                              label: v,
                              value: parseInt(v),
                            })),
                          ]}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 idx-input-margin-top">
                  <h6 className="mb-3">Fireplaces</h6>
                  <div className="row">
                    <div className="col-md-6 pl-2">
                      <div className="dropdown range-drop">
                        <Select
                          className="range-select"
                          value={lowerfilters.fireplacemin}
                          placeholder="Any"
                          onChange={(selectedValue) => {
                            dispatch(
                              changeModelMultiFilter({
                                fireplacemin: selectedValue?.value,
                              })
                            );
                            handleFilterChange("fireplaceMin", selectedValue);
                          }}
                          options={[
                            {
                              label: "Any",
                              value: null,
                            },
                            ...filterlist.fireplaces?.map((v: string) => ({
                              label: v,
                              value: parseInt(v),
                            })),
                          ]}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 pl-2">
                      <div className="dropdown custom-margin range-drop">
                        <Select
                          className="range-select"
                          value={lowerfilters.fireplacemax}
                          placeholder="Any"
                          onChange={(selectedValue) => {
                            dispatch(
                              changeModelMultiFilter({
                                fireplacemax: selectedValue?.value,
                              })
                            );
                            handleFilterChange("fireplaceMax", selectedValue);
                          }}
                          options={[
                            { label: "Any", value: null },
                            ...filterlist.fireplaces?.map((v: string) => ({
                              label: v,
                              value: parseInt(v),
                            })),
                          ]}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 idx-input-margin-top range-drop">
                  <h6 className="mb-3">Days on market</h6>

                  <Select
                    className="range-select"
                    // placeholder="Any"
                    value={lowerfilters.daysonMarket}
                    onChange={(selectedValue) => {
                      dispatch(
                        changeModelMultiFilter({
                          daysonMarket: selectedValue?.value,
                        })
                      );
                      handledaysonMarket(selectedValue);
                    }}
                    options={daysOptions}
                    placeholder="Any"
                  />
                </div>
                <div className="col-md-12 idx-input-margin-top ">
                  <h6 className="mb-4">Special Features</h6>
                </div>
                <div className="col-md-6">
                  <div className="row">
                    <div className="col-10">
                      <div className="special-feature">
                        <span className="mr-3">
                          <img src={BeachSun} />
                        </span>
                        <span>Waterfront</span>
                      </div>
                      <div className="special-feature">
                        <span className="mr-3">
                          <img src={BeachSun} />
                        </span>
                        <span>Riverfront</span>
                      </div>
                      <div className="special-feature">
                        <span className="mr-3">
                          <img src={BeachSun} />
                        </span>
                        <span>Lakefront</span>
                      </div>
                      <div className="special-feature">
                        <span className="mr-3">
                          <img src={SwimmingPool} />
                        </span>
                        <span>Pool in ground</span>
                      </div>
                      <div className="special-feature">
                        <span className="mr-3">
                          <img src={SwimmingPool} />
                        </span>
                        <span>Pool above ground</span>
                      </div>
                    </div>

                    <div className="col-2">
                      <div className="special-feature-input">
                        <input
                          className="form-check"
                          type="checkbox"
                          // value={topFilter?.waterfront}
                          onChange={(e) => {
                            // const selectedValue = { state: e.target.checked }; //@ts-ignore
                            // handleFilterChange("waterFront", selectedValue);
                            // handleChangeSpecialFeature(
                            //   "waterfront",
                            //   e.target.checked ? true : null
                            // );
                            dispatch(
                              changeSpecialFeature({
                                waterfront: e.target.checked ? true : null,
                              })
                            );
                          }}
                          // checked={topFilter.waterfront}
                          checked={specialFeature?.waterfront ? true : false}
                          id="flexCheckDefault"
                        />
                        <input
                          className="form-check"
                          type="checkbox"
                          // value={topFilter.riverfront}
                          onChange={(e) => {
                            // const selectedValue = { state: e.target.checked }; //@ts-ignore
                            // handleFilterChange("riverFront", selectedValue);
                            // handleChangeSpecialFeature(
                            //   "riverfront",
                            //   e.target.checked ? true : null
                            // );
                            dispatch(
                              changeSpecialFeature({
                                riverfront: e.target.checked ? true : null,
                              })
                            );
                          }}
                          // checked={topFilter?.riverfront}
                          checked={specialFeature?.riverfront ? true : false}
                          id="flexCheckDefault"
                        />
                        <input
                          className="form-check"
                          type="checkbox"
                          // value={topFilter.lakefront}
                          onChange={(e) => {
                            // const selectedValue = { state: e.target.checked }; //@ts-ignore
                            // handleFilterChange("lakeFront", selectedValue);
                            // handleChangeSpecialFeature(
                            //   "lakefront",
                            //   e.target.checked ? true : null
                            // );
                            dispatch(
                              changeSpecialFeature({
                                lakefront: e.target.checked ? true : null,
                              })
                            );
                          }}
                          // checked={topFilter?.lakefront}
                          checked={specialFeature?.lakefront ? true : false}
                          id="flexCheckDefault"
                        />
                        <input
                          className="form-check"
                          type="checkbox"
                          // value={topFilter.pool_In_Ground}
                          onChange={(e) => {
                            // const selectedValue = { state: e.target.checked }; //@ts-ignore
                            // handleFilterChange("poolGround", selectedValue);
                            // handleChangeSpecialFeature(
                            //   "pool_In_Ground",
                            //   e.target.checked ? true : null
                            // );
                            dispatch(
                              changeSpecialFeature({
                                pool_In_Ground: e.target.checked ? true : null,
                              })
                            );
                          }}
                          // checked={topFilter?.pool_In_Ground}
                          checked={
                            specialFeature?.pool_In_Ground ? true : false
                          }
                          id="flexCheckDefault"
                        />
                        <input
                          className="form-check"
                          type="checkbox"
                          // value={topFilter.pool_Above_Ground}
                          onChange={(e) => {
                            // const selectedValue = { state: e.target.checked }; //@ts-ignore
                            // handleFilterChange(
                            //   "poolAboveGround", // @ts-ignore
                            //   selectedValue
                            // );
                            // handleChangeSpecialFeature(
                            //   "pool_Above_Ground",
                            //   e.target.checked ? true : null
                            // );
                            dispatch(
                              changeSpecialFeature({
                                pool_Above_Ground: e.target.checked
                                  ? true
                                  : null,
                              })
                            );
                          }}
                          // checked={topFilter?.pool_Above_Ground}
                          checked={
                            specialFeature?.pool_Above_Ground ? true : false
                          }
                          id="flexCheckDefault"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="row">
                    <div className="col-10">
                      <div className="special-feature">
                        <span className="mr-3">
                          <img src={SwimmingPool} />
                        </span>
                        <span>Pool access</span>
                      </div>
                      <div className="special-feature">
                        <span className="mr-3">
                          <img src={AnimalHorse} />
                        </span>
                        <span>Horse permitted</span>
                      </div>
                      <div className="special-feature">
                        <span className="mr-3">
                          <img src={HouseFilter} />
                        </span>
                        <span>Out building</span>
                      </div>
                      <div className="special-feature">
                        <span className="mr-3">
                          <img src={GolfHole} />
                        </span>
                        <span>Golf course</span>
                      </div>
                    </div>
                    <div className="col-2">
                      <div className="special-feature-input">
                        <input
                          className="form-check"
                          type="checkbox"
                          // value={topFilter.pool_Access}
                          onChange={(e) => {
                            // const selectedValue = { state: e.target.checked }; //@ts-ignore
                            // handleChangeSpecialFeature(
                            //   "pool_Access",
                            //   e.target.checked ? true : null
                            // );
                            dispatch(
                              changeSpecialFeature({
                                pool_Access: e.target.checked ? true : null,
                              })
                            );
                          }}
                          checked={specialFeature?.pool_Access ? true : false}
                          id="flexCheckDefault"
                        />
                        <input
                          className="form-check"
                          type="checkbox"
                          // value={topFilter.horse_Permitted}
                          onChange={(e) => {
                            // const selectedValue = { state: e.target.checked }; //@ts-ignore
                            // handleChangeSpecialFeature(
                            //   "horse_Permitted",
                            //   e.target.checked ? true : null
                            // );
                            dispatch(
                              changeSpecialFeature({
                                horse_Permitted: e.target.checked ? true : null,
                              })
                            );
                          }}
                          checked={
                            specialFeature?.horse_Permitted ? true : false
                          }
                          id="flexCheckDefault"
                        />
                        <input
                          className="form-check"
                          type="checkbox"
                          // value={topFilter.out_Building}
                          onChange={(e) => {
                            // const selectedValue = { state: e.target.checked }; //@ts-ignore
                            // handleChangeSpecialFeature(
                            //   "out_Building",
                            //   e.target.checked ? true : null
                            // );
                            dispatch(
                              changeSpecialFeature({
                                out_Building: e.target.checked ? true : null,
                              })
                            );
                          }}
                          checked={specialFeature?.out_Building ? true : false}
                          id="flexCheckDefault"
                        />
                        <input
                          className="form-check"
                          type="checkbox"
                          // value={specialFeature.golf_Course}
                          onChange={(e) => {
                            // const selectedValue = { state: e.target.checked }; //@ts-ignore
                            // handleChangeSpecialFeature(
                            //   "golf_Course",
                            //   e.target.checked ? true : null
                            // );
                            dispatch(
                              changeSpecialFeature({
                                golf_Course: e.target.checked ? true : null,
                              })
                            );
                          }}
                          checked={specialFeature?.golf_Course ? true : false}
                          id="flexCheckDefault"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn footer-close-btn"
              data-bs-dismiss="modal"
              onClick={() => {
                handleClearAll();
                dispatch(clearAll());
                dispatch(onToggleFilter());
                sethandleFilterPopup(false);
              }}
            >
              Clear all
            </button>
            <button
              type="button"
              className="btn btn-center"
              onClick={(e) => {
                handleSubmit();
                dispatch(resetPageNo());
                dispatch(onToggleFilter());
                sethandleFilterPopup(false);
              }}
            >
              Apply filters
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllFilters;
